export default __webpack_public_path__ + "static/media/section1-bg2.2ae3e063.png";